import React from 'react'
import Loadable from 'react-loadable'

import Loader from 'components/LayoutComponents/Loader'

const loadable = loader =>
  Loadable({
    loader,
    delay: false,
    loading: () => <Loader />,
  })

const routes = [
  // System Pages
  {
    path: '/user/login',
    component: loadable(() => import('pages/user/login')),
    exact: true,
  },

  // Client Pages
  {
    path: '/dashboard',
    component: loadable(() => import('pages/dashboard')),
    exact: true,
  },
  {
    path: '/members',
    component: loadable(() => import('pages/members')),
    exact: true,
  },
  {
    path: '/packages',
    component: loadable(() => import('pages/packages')),
    exact: true,
  },
  {
    path: '/packages/:id',
    component: loadable(() => import('pages/package')),
    exact: true,
  },
  {
    path: '/coupons',
    component: loadable(() => import('pages/coupons')),
    exact: true,
  },
  {
    path: '/couriers',
    component: loadable(() => import('pages/couriers')),
    exact: true,
  },
  {
    path: '/couriers/:courierId',
    component: loadable(() => import('pages/couriers/CourierPricelist')),
    exact: true,
  },
  {
    path: '/couriers/:courierId/fuel-surcharge',
    component: loadable(() => import('pages/couriers/CourierPricelist/FuelSurcharge')),
    exact: true,
  },
  {
    path: '/couriers/:courierId/zones/:zoneId',
    component: loadable(() => import('pages/couriers/CourierPricelist/ZonePage')),
    exact: true,
  },
  {
    path: '/transactions',
    component: loadable(() => import('pages/transactions')),
    exact: true,
  },
  {
    path: '/order-payments',
    component: loadable(() => import('pages/order-payments')),
    exact: true,
  },
  {
    path: '/settings',
    component: loadable(() => import('pages/settings')),
    exact: true,
  },
  {
    path: '/settings/HarmonizedTariff',
    component: loadable(() => import('pages/settings/HarmonizedTariff')),
    exact: true,
  },
  {
    path: '/settings/delivery-duty',
    component: loadable(() => import('pages/settings/DeliveryDuty')),
    exact: true,
  },
  {
    path: '/settings/warehouses',
    component: loadable(() => import('pages/settings/Warehouses')),
    exact: true,
  },
  {
    path: '/settings/memberships',
    component: loadable(() => import('pages/settings/Memberships')),
    exact: true,
  },
  {
    path: '/settings/custom-links',
    component: loadable(() => import('pages/settings/CustomLinks')),
    exact: true,
  },
  {
    path: '/settings/courier-vendors',
    component: loadable(() => import('pages/settings/CourierVendors')),
    exact: true,
  },
  {
    path: '/member/:id',
    component: loadable(() => import('pages/member')),
    exact: true,
  },
  {
    path: '/member/:id/packages',
    component: loadable(() => import('pages/member/MemberPackages')),
    exact: true,
  },
  {
    path: '/member/:id/orders',
    component: loadable(() => import('pages/member/MemberOrders')),
    exact: true,
  },
  {
    path: '/member/:id/payment-methods',
    component: loadable(() => import('pages/member/PaymentsCoupons')),
    exact: true,
  },
  {
    path: '/member/:id/address-book',
    component: loadable(() => import('pages/member/AddressBook')),
    exact: true,
  },
  {
    path: '/member/:id/transactions',
    component: loadable(() => import('pages/member/MemberTransactions')),
    exact: true,
  },
  {
    path: '/member/:id/invites',
    component: loadable(() => import('pages/member/MemberInvites')),
    exact: true,
  },

  // Admin Pages

  {
    path: '/dataentry/:userId',
    component: loadable(() => import('pages/dataentry')),
    exact: true,
  },
  {
    path: '/orders',
    component: loadable(() => import('pages/orders')),
    exact: true,
  },
  {
    path: '/order-process/:id',
    component: loadable(() => import('pages/order-process')),
    exact: true,
  },
  {
    path: '/orders/:id',
    component: loadable(() => import('pages/order')),
    exact: true,
  },
  {
    path: '/shopper',
    component: loadable(() => import('pages/shopper')),
    exact: true,
  },
  {
    path: '/shopper/:id',
    component: loadable(() => import('pages/shop')),
    exact: true,
  },
  {
    path: '/payments',
    component: loadable(() => import('pages/payments')),
    exact: true,
  },
]

export default routes
